export default __webpack_public_path__ + "static/media/04_SilverAndPurple.2ba25fb0.png";